import { Organization } from 'api/types';
import { URLS } from 'config';
import { urlPart } from 'data';
import { queryClient } from 'stores';
import { ApiMutationConfig, ApiQueryConfig } from '../types';
import { createApiEndpoint, invalidateQueryKey } from '../utils';

type GetPartnerConfig = ApiQueryConfig<Organization, { $partnerId: number }>;
export const getPartner = createApiEndpoint<GetPartnerConfig>({
  url: `${URLS.app}/api/Organizations/$partnerId/Details`,
  method: 'GET',
});

type DeletePartnerServiceConfig = ApiMutationConfig<{
  OrganizationId: number;
  ServiceConfigId: number;
  ServiceId: number;
}>;
export const deletePartnerService =
  createApiEndpoint<DeletePartnerServiceConfig>({
    url: `${URLS.app}/api/Organizations/RemoveService`,
    method: 'POST',
  });

type PostApiDataConfig = ApiMutationConfig<unknown, { $partnerId: number }>;
export const postApiData = createApiEndpoint<PostApiDataConfig>({
  url: `${URLS.app}/api/Organizations/$partnerId/GenerateApiKey`,
  method: 'POST',
  onSuccess: () => {
    invalidateQueryKey({ url: URLS.account });
    invalidateQueryKey({ url: URLS.app });
    //TODO: remove when done migration APIs
    queryClient.invalidateQueries('subscribers');
    queryClient.invalidateQueries('workspaces');
  },
});

type PostPartnerSystemConfig = ApiMutationConfig<
  number,
  { $partnerId: urlPart }
>;

export const postPartnerSystem = createApiEndpoint<PostPartnerSystemConfig>({
  url: `${URLS.app}/api/Organizations/$partnerId/AddSystem`,
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
});

export const deletePartnerSystem = createApiEndpoint<PostPartnerSystemConfig>({
  url: `${URLS.app}/api/Organizations/$partnerId/RemoveSystem`,
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
});
